import script from "./NavSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./NavSidebar.vue?vue&type=style&index=0&id=03c98aba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c98aba"]])

export default __exports__